<template>
    <div id="before">
        <headers :title=getTit()></headers>
        <div v-if="loading">
            <div v-if="true">
                <div v-if="bookList.length"
                     v-for="(book,index) in bookList">
                    <div class="book_list">
                        <div class="title">
                            <p>{{book.text_data[0].title}}</p>
                            <i v-if="book.is_send && type==2"
                               class="is_send"></i>
                        </div>
                        <div class="text">
                            <p v-for="b in book.text_data">{{b.text}}</p>
                        </div>
                        <div class="btn clearfix"
                             v-if="type==2">
                            <div class="add_btn"
                                 v-if="book.on"
                                 @click="chooseBook(book,index,1)">加入</div>
                            <div class="dele_btn"
                                 @click="chooseBook(book,index,0)"
                                 v-else>移除</div>
                        </div>
                    </div>
                </div>
                <div v-if="wordList.length">
                    <ul class="word_list">
                        <h3>单词（{{wordList.length}}）</h3>
                        <li v-for="(word,index) in wordList"
                            class="clearfix">
                            <p>{{word.word}}</p>
                            <div class="btn"
                                 v-if="type==2">
                                <i class="is_send"
                                   v-show="word.is_send">发布过</i>
                                <div class="add_btn"
                                     v-if="word.on"
                                     @click="chooseWord(word,index,1)">加入</div>
                                <div class="dele_btn"
                                     @click="chooseWord(word,index,0)"
                                     v-else>移除</div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="bottom_btn clearfix"
                     v-if="type==2">
                    <div class="left_btn"><i></i><span>已选（{{number}}题）</span></div>
                    <div :class="['right_btn',{'able':number>0,'disable':number==0}]"
                         @click="toSend">去发布</div>
                </div>
            </div>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';

export default {
    data () {
        return {
            titles: null,
            loading: false,
            type: this.$route.params.type,
            wordList: [],
            bookList: [],
            number: 0,//选了几项
        }
    },
    computed: {
        catalogId () {
            if (this.type != 2) {
                return this.$route.query.id
            } else {
                let _chooseData = this.$store.state.english.beforeData.book;
                return _chooseData && _chooseData.length ? _chooseData.join(',') : false

            }
        },
        wordId () {
            if (this.type != 2) {
                return this.$route.query.id
            } else {
                let _chooseData = this.$store.state.english.beforeData.word;
                return _chooseData && _chooseData.length ? _chooseData.join(',') : false

            }
        }
    },
    async created () {
        let _this = this;
        if (!this.wordId && !this.catalogId) {
            this.$router.go(-1);
        } else {
            if (this.type != 1 && this.wordId) {
                await this.getWord(this.wordId)
            }
            if (this.type != 0 && this.catalogId) {
                await this.getBook(this.catalogId)
            }
        }
    },
    components: {
        headers,
        loadingS
    },
    methods: {
        getWord (id) {
            this.$http.post(API_URL_TASK_API + '/english/send/word/list', { catalog_id: id, sid: 91 }).then(res => {
                if (res.data.response === 'ok') {
                    res = res.data;
                    this.wordList = res.data.word_list;
                    this.wordList.forEach(w => {
                        w.on = false;
                    })
                    this.number += this.wordList.length;
                    if (this.type == 0 || id) {
                        this.loading = true;
                    }
                }
            })
        },
        getBook (id) {
            this.$http.post(API_URL_TASK_API + '/english/send/text/list', { catalog_ids: id, sid: 91 }).then(res => {
                if (res.data.response === 'ok') {
                    res = res.data;
                    this.bookList = res.data;
                    this.bookList.forEach(b => {
                        b.on = false;
                    })
                    this.number += this.bookList.length;
                    if (this.type != 0) {
                        this.loading = true;
                    }
                }
            })
        },
        chooseWord (data, index, type) {
            data.on = !data.on;
            this.wordList.splice(index, 1, this.wordList[index]);
            if (type) {
                this.number++;
            } else {
                this.number--;
            }
        },
        chooseBook (data, index, type) {
            data.on = !data.on;
            this.bookList.splice(index, 1, this.bookList[index]);
            if (type) {
                this.number++;
            } else {
                this.number--;
            }
        },
        toSend () {
            let _array = [];
            if (this.wordList.length) {
                this.wordList.forEach(w => {
                    if (!w.on) {
                        let _o = {
                            'qid': w.id,
                            'type': 4
                        }
                        _array.push(_o)
                    }
                })
            }
            if (this.bookList.length) {
                this.bookList.forEach(b => {
                    // //console.log(b.on)
                    if (!b.on) {
                        let _o = {
                            'qid': b.pool_id,
                            'type': 1
                        }
                        _array.push(_o)
                    }
                })
            }
            if (_array.length) {
                this.$store.commit('setSendData', _array);
                this.$router.push('/english/release/91/1')
            }
        },
        getTit () {
            if (this.type == 0) {
                this.titles = "单词预览"
            } else if (this.type == 1) {
                this.titles = "课文预览"
            } else if (this.type == 2) {
                this.titles = "习题预览"
            }
            return this.titles
        }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#before {
    font-size: 30px / $ppr;
    padding-bottom: 100px / $ppr;
}

.word_list {
    line-height: 96px / $ppr;
    background: #fff;
    h3,
    li {
        font-size: 30px / $ppr;
        padding: 0 25px / $ppr;
        border-bottom: 1px / $ppr solid #e8e8e8;
    }
    li:last-child {
        border-bottom: none;
    }
    li {
        p {
            float: left;
            // display:inline-block;
            width: 400px / $ppr;
            // background:#ccc;
        }
        .btn {
            float: right;
        }
        .is_send {
            display: inline-block;
            width: 120px / $ppr;
            height: 56px / $ppr;
            line-height: 56px / $ppr;
            text-align: center;
            color: #fff;
            background: rgba(44, 172, 148, 0.6);
            border-radius: 28px / $ppr;
            font-size: 24px / $ppr;
            margin-right: 8px / $ppr;
        }
        .dele_btn,
        .add_btn {
            display: inline-block;
            margin-top: 22px / $ppr;
            // float:right;
        }
    }
}

.book_list {
    background: #fff;
    margin-bottom: 25px / $ppr;
    .title,
    .text {
        line-height: 46px / $ppr;
        padding: 25px / $ppr;
        border-bottom: 1px / $ppr solid #e8e8e8;
    }
    .title {
        position: relative;
    }
    .is_send {
        display: block;
        width: 100px / $ppr;
        height: 56px / $ppr;
        background: url("./img/send.png") 0 0 no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        top: 20px / $ppr;
    }
    .btn {
        display: block;
        .dele_btn {
            float: right;
            margin: 22px / $ppr 25px / $ppr 0 0;
        }
        .add_btn {
            float: right;
            margin: 22px / $ppr 25px / $ppr 0 0;
        }
    }
}

.btn {
    height: 96px / $ppr;
    display: inline-block;
    .dele_btn {
        // float:right;
        border: 1px / $ppr solid #ff6600;
        border-radius: 24px / $ppr;
        color: #ff6600;
        line-height: 50px / $ppr;
        height: 48px / $ppr;
        width: 122px / $ppr;
        text-align: center;
        font-size: 28px / $ppr;
    }
    .add_btn {
        display: inline-block;
        border: 1px / $ppr solid $c-theme;
        border-radius: 24px / $ppr;
        color: $c-theme;
        line-height: 50px / $ppr;
        height: 48px / $ppr;
        width: 122px / $ppr;
        text-align: center;
        font-size: 28px / $ppr;
    }
}

.bottom_btn {
    width: 100%;
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    font-size: 30px / $ppr;
    text-align: center;
    .left_btn {
        width: 70%;
        float: left;
        background: #f0f0f0;
        color: #333;
        position: relative;
        i {
            position: absolute;
            z-index: 1;
            top: 25px / $ppr;
            display: inline-block;
            width: 50px / $ppr;
            height: 42px / $ppr;
            background: url("./img/icon1.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
        span {
            display: inline-block;
            padding-left: 60px / $ppr;
        }
    }
    .right_btn {
        width: 30%;
        float: right;
    }
    .able {
        color: #fff;
        background: #5e89ef;
    }
    .disable {
        color: #999;
        background: #ccc;
    }
}
</style>
